export const TITLE = {
  en_US: 'Oops!',
  pt_BR: 'Ops!',
  es_ES: '¡Ups!',
};

export const GO_HOMEPAGE = {
  en_US: 'Go to Homepage',
  pt_BR: 'Ir para Homepage',
  es_ES: 'Ir a la Homepage',
};

export const DESCRIPTION = {
  en_US: 'Something went wrong!',
  es_ES: '¡Algo salió mal!',
  pt_BR: 'Algo deu errado!',
};
